export default __webpack_public_path__ + "static/profnsatil-efa42e9f7ed21ec9d6dedd32ce7f144c.jpg";